import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  icon,
  action,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-star-smile-line"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
          {icon && (
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
              <i className={`${icon} text-lg`}></i>
            </span>
          )}
          {title}
        </h2>
        {desc && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{desc}</p>}
      </div>
      {action}
    </div>
  );
}